'use strict';

var SpecialEventsGridNewCalendarDirective = function SpecialEventsGridNewCalendarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/special-events-grid-new-calendar.html'),
    requires: '^rmNewCalendar',
    controller: 'SpecialEventsGridController',
    scope: {
      gridId: '=',
      gridData: '=',
      calendarName: '=',
      importCallback: '=',
      removeEventsCallback: '='
    },
    link: function link(scope, element) {
      element.on('cellendedit', scope.setEventType);
    }
  };
};
SpecialEventsGridNewCalendarDirective.$inject = [];
module.exports = SpecialEventsGridNewCalendarDirective;